
  <div class="container py-5">
    <div class="row justify-content-center pt-5">
      <div class="col-md-6">
        <div class="bg-light p-5 rounded shadow">
          <img src="assets/logo/momma.png" alt="Logo" class="img-fluid mx-auto d-block" style="max-width: 100%; height: auto;" />
          <h3 class="text-center my-4">Login | تسجيل الدخول</h3>
          <button class="btn btn-success btn-block w-100" (click)="loginWithMicrosoft()">Sign in with Microsoft SSO</button>
          <div *ngIf="errorMessage" class="text-danger text-center mt-3 fs-3">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
  